// Google Cloud VM Trading API Configuration
export const VM_TRADING_API = {
  // VM URLs from environment variables (fallback to production via proxy for development)
  BASE_URL: import.meta.env.VITE_VM_API_BASE_URL || '/vm-api',
  WS_URL: import.meta.env.VITE_VM_WS_URL || 'wss://stewies-api.stewietrader.com:8000/socket.io/',
  // Development proxy URLs to avoid CORS issues
  DEV_BASE_URL: '/vm-api',
  DEV_WS_URL: 'wss://stewies-api.stewietrader.com:8000/socket.io/',
  // Production domain - Using HTTPS on port 8000 with SSL certificates
  PRODUCTION_BASE_URL: '/vm-api',
  PRODUCTION_WS_URL: 'wss://stewies-api.stewietrader.com:8000/socket.io/',
  ENDPOINTS: {
    HEALTH: '/api/health',
    PORTFOLIO: '/api/portfolio', 
    STRATEGIES: '/api/strategies',
    STRATEGIES_START: '/api/strategies/start',
    MARKET_DATA: '/api/market-data',
    EMERGENCY_STOP: '/api/emergency-stop',
    // Legacy endpoints (not available on current VM)
    ENGINE_START: '/api/engine/start',
    ENGINE_STOP: '/api/engine/stop',
    ENGINE_STATUS: '/api/engine/status',
    BACKTEST: '/api/backtest/run',
    ORDERS: '/api/orders',
    POSITIONS: '/api/positions',
    ACCOUNT: '/api/portfolio' // Map account requests to portfolio endpoint
  }
};

// Legacy API configuration (fallback)
export const LEGACY_API = {
  BASE_URL: import.meta.env.VITE_BACKEND_API_URL || 'https://stewie.api.clewis.me'
};

// Development proxy configuration (no /api prefix to avoid duplication)
export const DEV_PROXY = '';

// Determine which API to use based on environment
export const getApiConfig = () => {
  const isDev = process.env.NODE_ENV === 'development';
  const hasVmUrl = !!import.meta.env.VITE_VM_API_BASE_URL;
  
  // Check if we're in production
  const isProduction = typeof window !== 'undefined' && (
    window.location.hostname === 'stewietrader.com' ||
    window.location.hostname === 'www.stewietrader.com' ||
    window.location.origin.includes('stewietrader.com')
  );
  
  // Get the appropriate base URL
  const getTradingBaseUrl = () => {
    if (isProduction) {
      // Always use production domain in production
      return VM_TRADING_API.PRODUCTION_BASE_URL;
    }
    
    if (isDev) {
      // Development: ALWAYS use proxy to avoid CORS issues
      console.log('🔧 API Config: Using development proxy for VM API');
      return VM_TRADING_API.DEV_BASE_URL; // Always use /vm-api proxy in development
    }
    
    // Production build but not on production domain: use env var or production domain
    const envUrl = VM_TRADING_API.BASE_URL;
    if (envUrl && envUrl !== 'http://localhost:8000' && !envUrl.includes('35.245.64.115')) {
      return envUrl;
    }
    
    // Final fallback to production domain (never IP)
    return VM_TRADING_API.PRODUCTION_BASE_URL;
  };
  
  const getTradingWsUrl = () => {
    if (isProduction) {
      return VM_TRADING_API.PRODUCTION_WS_URL;
    }
    
    if (isDev) {
      // Development: use proxy-compatible WebSocket URL
      console.log('🔧 API Config: Using development WebSocket URL');
      return VM_TRADING_API.DEV_WS_URL; // Always use the HTTPS domain in development
    }
    
    // Fallback to production WebSocket URL
    return VM_TRADING_API.PRODUCTION_WS_URL;
  };
  
  return {
    // Primary: Use VM for trading operations
    TRADING_BASE_URL: getTradingBaseUrl(),
    TRADING_WS_URL: getTradingWsUrl(),
    
    // Secondary: Use legacy for non-trading operations or fallback
    LEGACY_BASE_URL: isDev ? DEV_PROXY : LEGACY_API.BASE_URL,
    
    // Environment info
    IS_DEV: isDev,
    USE_VM_TRADING: import.meta.env.VITE_USE_VM_TRADING !== 'false',
    IS_PRODUCTION: isProduction
  };
};

export const RECAPTCHA_SITE_KEY = '6Le4at8qAAAAM3QEo98G7_JJ6gZ4lYHuth6qIN7';
